import { useTranslation } from 'react-i18next'

const LEVEL_COLORS: Record<number, string> = {
  1: 'bg-success/10 text-success border-success/20',
  2: 'bg-info/10 text-info border-info/20',
  3: 'bg-warning/10 text-warning border-warning/20',
  4: 'bg-primary/10 text-primary border-primary/20',
  5: 'bg-destructive/10 text-destructive border-destructive/20',
}

export function LevelBadge({ level }: { level: number }) {
  const { t } = useTranslation()
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-[10px] font-semibold uppercase tracking-wider border ${LEVEL_COLORS[level] || LEVEL_COLORS[1]}`}
    >
      L{level} {t(`admin.labels.levels.${level}`) || ''}
    </span>
  )
}
